type LocaleCode = string;

export type ParsedJsonCountry = {
  code: string;
  countryCode: number;
  names: Partial<Record<LocaleCode, string>>;
};

export type CountryStoreEntity = {
  countries: ParsedJsonCountry[];
  currentLocale: string | undefined;
};

export interface Country {
  name: string;
  code: string;
  countryCode: number;
}

export type CountryMap = Record<string, Country>;

export const EntityStoreKey = 'countries';
